import type { DomApplier } from '../cssFeatures.types'

export const VISUAL_FOCUS_ON_SELECTOR =
	'#SITE_CONTAINER.focus-ring-active :not(.has-custom-focus):not(.ignore-focus):not([tabindex="-1"]):focus, #SITE_CONTAINER.focus-ring-active :not(.has-custom-focus):not(.ignore-focus):not([tabindex="-1"]):focus ~ .wixSdkShowFocusOnSibling'
/* needed for elements that have overflow scroll or hidden */
const INNER_FOCUS_SELECTOR = '.has-inner-focus-ring'

const LINE1 = '0 0 0 1px #ffffff'
const LINE2 = '0 0 0 3px #116dff'

const BORDER_EXP = '0 0 0 2px #116dff'

const getOuterFocusRing = (useExperimentalStyle: boolean) => {
	if (useExperimentalStyle) {
		return BORDER_EXP
	}
	return `${LINE1}, ${LINE2}`
}

const getInnerFocusRing = (useExperimentalStyle: boolean) => {
	if (useExperimentalStyle) {
		return BORDER_EXP
	}
	return `inset ${LINE1}, inset ${LINE2}`
}

const VAR_NAME = '--focus-ring-box-shadow'

export const accessibilityDomApplier: DomApplier<'accessibility'> = (__, ___, ____, { accessibilityStyle }) => {
	const { isVisualFocusDisabled, isExperimentChangeFocusRing: isExperimentalStyle } = accessibilityStyle
	if (isVisualFocusDisabled) {
		return null
	}

	const OUTER_FOCUS_RING = getOuterFocusRing(isExperimentalStyle)
	const INNER_FOCUS_RING = getInnerFocusRing(isExperimentalStyle)

	const VISUAL_FOCUS_ON_VALUE = {
		[VAR_NAME]: OUTER_FOCUS_RING,
		'box-shadow': `var(${VAR_NAME}) !important`,
		'z-index': '1',
	}

	const INNER_FOCUS_STYLES = {
		[VAR_NAME]: `${INNER_FOCUS_RING} !important`,
	}

	return {
		[VISUAL_FOCUS_ON_SELECTOR]: VISUAL_FOCUS_ON_VALUE,
		[INNER_FOCUS_SELECTOR]: INNER_FOCUS_STYLES,
	}
}
